module.exports = __webpack_public_path__ + "static/desktop/img/step-tablet.0e3255d1.png";